import { InputLabel, TextField, Box, Grid, Typography, Button } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { FC, useEffect, useState } from 'react';
import Select from 'react-select';

import { useNavigate } from 'react-router-dom';
import { palette } from 'src/theme/style/palette';
import { currencyList } from 'src/components/shared/constants/currencyList';
import { usePostBodyWithJwtMutation } from 'src/redux/api/cabinet';
import { iLogout, updBalances } from 'src/redux/slices/app';
import { RootState } from 'src/redux';
import { Alerting } from 'src/views/components_cabinet/Alerting';
import { ReturnBalance } from 'src/components/return-balance/ReturnBalance';

const customStyles = {
    control: (base: any) => ({
        ...base,
        borderRadius: '4px',
        padding: '2px 6px',
        borderColor: palette.blue,
        boxShadow: 'none',
        height: "55px",
        '&:hover': {
            borderColor: palette.blue,
        },
    }),
    menu: (base: any) => ({
        ...base,
        borderRadius: '4px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected ? palette.success : base.backgroundColor,
        color: state.isSelected ? '#fff' : base.color,
        '&:hover': {
            backgroundColor: palette.successLight,
            color: '#000',
        },
    }),
    placeholder: (base: any) => ({
        ...base,
        color: palette.blue,
    }),
};

interface Props {
    updateStateModal: () => void
}

const MIN_AMOUNT = 1.1;

export const P2pHeader: FC<Props> = ({ updateStateModal }) => {
    const [requisites, setRequisites] = useState<any[]>([])
    const { data: user } = useSelector((state: RootState) => state.app);
    const [outAmount, setOutAmount] = useState<string>('');
    const [exchangeRate, setExchangeRate] = useState<string>('');
    const [selectedCurrency, setSelectedCurrency] = useState<{ label: string, value: string }>(currencyList[1]);
    const [activeRequisite, setActiveRequisite] = useState<any>(undefined);
    const dispatch = useDispatch();
    const nav = useNavigate();
    const [getAlert, setAlert] = useState<{ type: number; msg: string } | undefined>(undefined);

    const handleChange = (selectedOption: any) => {
        setSelectedCurrency(selectedOption);
    };

    const handleChangeRequisite = (selectedOption: any) => {
        setActiveRequisite(selectedOption);
    };

    // ЗАПРОС СОЗДАНИЕ
    const [getData, {
        isLoading: addNewExchange,
    }] = usePostBodyWithJwtMutation();

    const getDataFunction = async (data: any = []) => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getData({
                body: data,
                route: 'p2p-add',
                jwt,
            }).unwrap();

            dispatch(updBalances(payload.data));
            nav(0);
        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setAlert({ type: 2, msg: error.data?.message });
        }
    }

    const [getDataExh, { isLoading: _exchangeLoad }] = usePostBodyWithJwtMutation();

    const getDatagetExch = async (data: any = []) => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getDataExh({
                body: data,
                route: 'p2p-accounts',
                jwt,
            }).unwrap();

            setRequisites(payload.data);

        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setAlert({ type: 2, msg: error.data?.message });
        }
    }

    const addNewAds = () => {
        getDataFunction({
            amount: parseFloat(outAmount),
            currency: selectedCurrency.value || "RUB",
            account: activeRequisite?.id || 0,
            course: parseFloat(exchangeRate),
        });
    }

    useEffect(() => {
        getDatagetExch()
    }, [])

    const outAmountNum = parseFloat(outAmount) || 0;
    const exchangeRateNum = parseFloat(exchangeRate) || 0;
    const userBalance = user?.balance || 0;
    const remainingBalance = userBalance - outAmountNum;
    const finalAmount = outAmountNum * exchangeRateNum;

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} lg={3}>
                            <InputLabel sx={{ mb: 1 }}>Сумма продажи USDT</InputLabel>

                            <TextField
                                fullWidth
                                autoComplete="off"
                                label="Сумма"
                                value={outAmount}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onInput={(e) => {
                                    const target = e.target as HTMLInputElement;
                                    let value = target.value;

                                    // Разрешаем только цифры и одну точку
                                    value = value.replace(/[^\d.]/g, '');

                                    // Разрешаем только одну точку
                                    const parts = value.split('.');
                                    if (parts.length > 2) {
                                        value = parts[0] + '.' + parts.slice(1).join('');
                                    }

                                    // Ограничиваем до 4 знаков после точки
                                    if (parts.length === 2 && parts[1].length > 4) {
                                        value = parts[0] + '.' + parts[1].slice(0, 4);
                                    }

                                    target.value = value;
                                    setOutAmount(value);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <InputLabel sx={{ mb: 1 }}>Курс обмена</InputLabel>

                            <TextField
                                fullWidth
                                autoComplete="off"
                                label="Курс"
                                value={exchangeRate}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onInput={(e) => {
                                    const target = e.target as HTMLInputElement;
                                    let value = target.value;

                                    // Разрешаем только цифры и одну точку
                                    value = value.replace(/[^\d.]/g, '');

                                    // Разрешаем только одну точку
                                    const parts = value.split('.');
                                    if (parts.length > 2) {
                                        value = parts[0] + '.' + parts.slice(1).join('');
                                    }

                                    // Ограничиваем до 4 знаков после точки
                                    if (parts.length === 2 && parts[1].length > 4) {
                                        value = parts[0] + '.' + parts[1].slice(0, 4);
                                    }

                                    target.value = value;
                                    setExchangeRate(value);
                                }}
                            />

                            <Box
                                sx={{
                                    backgroundColor: '#fff3e0',
                                    border: '1px solid #ffb74d',
                                    borderRadius: 1,
                                    padding: 1,
                                    mt: 1,
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 0.5
                                }}
                            >
                                <InfoOutlinedIcon sx={{ color: '#f57c00', fontSize: 18, mt: 0.1 }} />
                                <Typography variant="caption" sx={{ color: '#e65100', lineHeight: 1.4 }}>
                                    Обязательно укажите курс, по которому будете продавать USDT
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} lg={3} sx={{ position: 'relative' }}>
                            <InputLabel sx={{ mb: 1 }}>Валюта получения</InputLabel>
                            <Select
                                value={selectedCurrency}
                                onChange={handleChange}
                                options={currencyList}
                                getOptionLabel={(e: any) => e.label}
                                getOptionValue={(e: any) => e.value}
                                placeholder="Выберите валюту"
                                isSearchable={true}
                                styles={{
                                    ...customStyles,
                                    menuPortal: (base: any) => ({
                                        ...base,
                                        zIndex: 9999,
                                    }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        </Grid>
                        <Grid item xs={12} lg={3} sx={{ position: 'relative' }}>
                            <InputLabel sx={{ mb: 1 }}>Реквизиты получения</InputLabel>
                            <Select
                                isDisabled={_exchangeLoad}
                                value={activeRequisite}
                                onChange={handleChangeRequisite}
                                options={requisites}
                                getOptionLabel={(e: any) => `${e.bank} (${e.currency})`}
                                getOptionValue={(e: any) => e.id}
                                placeholder="Выберите реквизиты"
                                isSearchable={true}
                                styles={{
                                    ...customStyles,
                                    menuPortal: (base: any) => ({
                                        ...base,
                                        zIndex: 9999,
                                    }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        </Grid>
                    </Grid>

                    <Box mt={2}>
                        {outAmountNum > 0 ? <>
                            {remainingBalance < 0 ?
                                <>
                                    <Typography sx={{ color: palette.error }}>
                                        Для продажи недостаточно <Box component='span' sx={{ fontWeight: 'bold' }}><ReturnBalance num={outAmountNum - userBalance} /></Box>
                                    </Typography>
                                </>
                                :
                                <Typography>
                                    Останется  <Box component='span' sx={{ fontWeight: 'bold' }}><ReturnBalance num={remainingBalance} /></Box> (<Box component='span' sx={{ fontWeight: 'bold' }}><ReturnBalance num={userBalance} /></Box> - <Box component='span' sx={{ fontWeight: 'bold' }}><ReturnBalance num={outAmountNum} /></Box>)
                                </Typography>
                            }
                        </> :
                            <Typography>
                                Баланс USDT: <Box component='span' sx={{ fontWeight: 'bold' }}><ReturnBalance num={userBalance} /></Box>
                            </Typography>
                        }

                        {outAmountNum > 0 && exchangeRateNum >= 1 && (
                            <Typography sx={{ mt: 1 }}>
                                Сумма к получению: <Box component='span' sx={{ fontWeight: 'bold', color: palette.success }}>{finalAmount.toFixed(2)} {selectedCurrency.value}</Box>
                            </Typography>
                        )}
                    </Box>
                    <Box my={2}>
                        {outAmountNum < MIN_AMOUNT && outAmountNum > 0 &&
                            <Typography variant='h6' color='error' mb={3}>
                                Продажа возможна только при выводе от {MIN_AMOUNT.toFixed(2)} USDT
                            </Typography>
                        }
                        {remainingBalance < MIN_AMOUNT && outAmountNum >= MIN_AMOUNT &&
                            <Typography variant='h6' color='error' mb={3}>
                                Продажа возможна только при остатке на балансе от {MIN_AMOUNT.toFixed(2)} USDT
                            </Typography>}
                        {exchangeRateNum < 1 && exchangeRateNum > 0 &&
                            <Typography variant='h6' color='error' mb={3}>
                                Курс обмена не может быть меньше 1
                            </Typography>}

                        <Button variant='contained'
                            onClick={addNewAds}
                            disabled={
                                remainingBalance < MIN_AMOUNT ||
                                addNewExchange ||
                                !outAmount ||
                                !exchangeRate ||
                                outAmountNum < MIN_AMOUNT ||
                                exchangeRateNum < 1 ||
                                outAmountNum > userBalance ||
                                (selectedCurrency.value === 'USDT' && outAmountNum < MIN_AMOUNT)
                            }
                        >
                            Выставить на продажу
                        </Button>
                    </Box>
                </Grid>
            </Grid>

        </>
    )
}